import { guardedCustomElement } from '../utils/guarded-custom-element';
import { SDSButtonComponent } from './sds-button.component';

@guardedCustomElement('sds-button')
export class SDSButton extends SDSButtonComponent {}

declare global {
	interface HTMLElementTagNameMap {
		'sds-button': SDSButton;
	}
}
